import React from 'react';
import styles from '../styles/styles.module.css';
import { AppState } from '../../../Redux/store';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setEmail, setPassword } from '../../../Redux/slices/authSlice';
import QrCode from './QrCode';

const RegularInputFields: React.FC = () => {
  const { qrCodeUrl, email, password } = useSelector(
    (state: AppState) => state.auth
  );
  const dispatch = useDispatch();

  return qrCodeUrl ? (
    <QrCode qrCodeUrl={qrCodeUrl} />
  ) : (
    <>
      <div className={styles.inputContainer}>
        <p className={styles.label}>Email</p>
        <input
          onChange={(e) => dispatch(setEmail(e.target.value))}
          value={email}
          className={styles.inputElement}
          type="email"
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <p className={styles.label}>Password</p>
        <input
          onChange={(e) => dispatch(setPassword(e.target.value))}
          value={password}
          className={styles.inputElement}
          type="password"
          required
        />
      </div>
    </>
  );
};

export default RegularInputFields;
